(function () {
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.documentElement.classList.add('pii-motion');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  function scan() { document.querySelectorAll('.pii [data-reveal]:not(.is-in)').forEach(function (el) { io.observe(el); }); }
  scan();
  document.addEventListener('shopify:section:load', scan);
})();
